import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { consentService, ConsentValue } from "../services/consent.service";
import { COOKIE_BANNER_TEXT } from "../services/privacyPolicy.data";
import { routeService } from "../services/route.service";

export const OPEN_COOKIE_SETTINGS_EVENT = "open-cookie-settings";

export function CookieConsentBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        consentService.initConsent();
        setIsVisible(!consentService.hasDecision());

        const openSettings = () => setIsVisible(true);
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
        return () =>
            window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
    }, []);

    function handleChoice(value: ConsentValue) {
        consentService.setConsent(value);
        setIsVisible(false);
    }

    if (!isVisible) return null;

    return (
        <div
            dir="rtl"
            role="dialog"
            aria-live="polite"
            aria-label="הסכמה לשימוש בעוגיות"
            className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-2px_12px_rgba(0,0,0,0.08)]"
        >
            <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col md:flex-row md:items-center gap-4">
                <p className="text-sm text-gray-600 flex-1 leading-relaxed text-right">
                    {COOKIE_BANNER_TEXT}{" "}
                    <Link
                        to={routeService.PRIVACY_POLICY}
                        className="underline text-[#C00035] whitespace-nowrap"
                    >
                        מדיניות פרטיות
                    </Link>
                </p>
                <div className="flex items-center gap-3 shrink-0">
                    <button
                        onClick={() => handleChoice("rejected")}
                        className="px-5 h-10 rounded-[12px] border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50"
                    >
                        דחייה
                    </button>
                    <button
                        onClick={() => handleChoice("accepted")}
                        className="px-5 h-10 rounded-[12px] bg-[#C00035] text-white text-sm font-semibold hover:opacity-90"
                    >
                        אישור
                    </button>
                </div>
            </div>
        </div>
    );
}
